import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MentorCardStatusesSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function MentorCardStatusesSubTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);

  const load = () => {
    setLoading(true);
    setError(null);
    axios
      .get(`${API_URL}/api/mentor-card-statuses`)
      .then((res) => setList(res.data || []))
      .catch((err) => setError(err.response?.data?.detail || err.message || 'Ошибка загрузки'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const setStatus = (mentorCardId, isActive) => {
    setUpdatingId(mentorCardId);
    axios
      .patch(`${API_URL}/api/mentor-card-statuses/${mentorCardId}`, { is_active: isActive })
      .then(() => load())
      .catch((err) => {
        alert(err.response?.data?.detail || err.message || 'Ошибка обновления');
      })
      .finally(() => setUpdatingId(null));
  };

  const formatDate = (iso) => {
    if (!iso) return '—';
    try {
      const d = new Date(iso);
      return d.toLocaleString('ru-RU', {
        dateStyle: 'short',
        timeStyle: 'short',
      });
    } catch {
      return iso;
    }
  };

  if (loading) {
    return (
      <div className="mentor-card-statuses-subtab">
        <p className="mentor-card-statuses-loading">Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mentor-card-statuses-subtab">
        <p className="mentor-card-statuses-error">{error}</p>
      </div>
    );
  }

  return (
    <div className="mentor-card-statuses-subtab">
      <h3 className="mentor-card-statuses-title">Статусы карточек менторов</h3>
      <p className="mentor-card-statuses-hint">
        Онлайн — карточка отображается как активная. Офлайн — неактивная. Переключение в портале ментора возможно только при выполнении условий (верификация, услуги, описание, навыки).
      </p>
      <div className="mentor-card-statuses-table-wrap">
        <table className="mentor-card-statuses-table">
          <thead>
            <tr>
              <th>ID карточки</th>
              <th>Ментор (логин)</th>
              <th>Статус</th>
              <th>Дата изменения</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan={5}>Нет карточек менторов</td>
              </tr>
            ) : (
              list.map((row) => (
                <tr key={row.mentor_card_id}>
                  <td>{row.mentor_card_id}</td>
                  <td>
                    <span className="mentor-card-statuses-mentor-name">{row.mentor_name || '—'}</span>
                    {row.mentor_login && (
                      <span className="mentor-card-statuses-mentor-login"> ({row.mentor_login})</span>
                    )}
                  </td>
                  <td>
                    <span className={`mentor-card-statuses-badge ${row.is_active === 1 ? 'mentor-card-statuses-badge-online' : 'mentor-card-statuses-badge-offline'}`}>
                      {row.is_active === 1 ? 'Онлайн' : 'Офлайн'}
                    </span>
                  </td>
                  <td>{formatDate(row.changed_at)}</td>
                  <td>
                    {updatingId === row.mentor_card_id ? (
                      <span className="mentor-card-statuses-updating">Сохранение…</span>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="mentor-card-statuses-btn mentor-card-statuses-btn-online"
                          onClick={() => setStatus(row.mentor_card_id, 1)}
                          disabled={row.is_active === 1}
                        >
                          Включить
                        </button>
                        <button
                          type="button"
                          className="mentor-card-statuses-btn mentor-card-statuses-btn-offline"
                          onClick={() => setStatus(row.mentor_card_id, 0)}
                          disabled={row.is_active === 0}
                        >
                          Выключить
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MentorCardStatusesSubTab;
